<template>
  <div class="index" id="anchor">
    <Seacher></Seacher>

    <!-- translist start -->
    <div class="translist">
      <div class="Block_Top notranslate">
        <span class="notranslate"
          >Transactions<b class="notranslate">({{ total }})</b></span
        >
      </div>
      <div class="resume-list">
        <div class="pool_main">
          <div class="tags">
            <div class="indexList">
              <div class="Block_list">
                <ul class="block_list_Top">
                  <li>Txn Hash</li>
                  <li>Type</li>
                  <li class="xila">Age</li>
                  <li>From</li>
                  <li>To</li>
                  <li>Amout</li>
                  <!-- <li>Amount</li> -->
                </ul>
              </div>
              <div class="Block_List_center notranslate">
                <ul>
                  <li
                    v-for="(transfer, index) in list1.slice(0, 20)"
                    :key="index"
                  >
                    <p @click="goDetail('txnhash', transfer)">
                      {{ transfer.txHash1 }}
                    </p>
                    <p>{{ transfer.functions }}</p>
                    <p>{{ transfer.tradeTime }}</p>
                    <p @click="goDetail('address', transfer.fromEvmAddress)">
                      {{ transfer.fromEvmAddress1 }}
                    </p>
                    <p
                      @click="goDetail('address', transfer.toEvmAddress)"
                      v-if="transfer.toEvmAddress !== ''"
                    >
                      {{ transfer.toEvmAddress1 }}
                    </p>
                    <p style="color: #8d8d8d" v-else>...</p>
                    <p @click="goDetail('hash', transfer)" style="color: #fff">
                      {{ transfer.tokenAmount }}<img :src="transfer.logo" />
                      <span>{{ transfer.symbol }}</span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="block">
          <el-pagination
            background
            small
            :current-page.sync="pageNum"
            :page-size="20"
            :pager-count="5"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- translist end -->
  </div>
</template>

<script>
import { formatSeconds, getSubStr,formattedNumber } from "@/utils/utils";
import Seacher from "@/components/m/Seacher.vue";
import { ContractTxList } from "../../assets/server/api.js";
export default {
  components: {
    Seacher,
  },
  data() {
    return {
      pageSize: 1,
      total: null,
      pageNum: 1,
      pagerCount: 0,
      transferList: [],
      list1: [],
      imgurl: require("@/assets/pc/Index/indexlogo.png"),
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  created() {
    this.pageNum = this.getContextData("tiaozhuan") || 1;
  },
  mounted() {
    this.getContractTxList();
  },
  destroyed() {},
  methods: {
    setContextData: function (key, value) {
      if (typeof value == "string") {
        sessionStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
    },
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
    handleCurrentChange(currentPage) {
      // sessionStorage.removeItem("tiaozhuan");
      // this.pageNum = currentPage;
      // this.setContextData("tiaozhuan", this.pageNum);
      // document.querySelector("#anchor").scrollIntoView(true);
      this.getContractTxList();
    },
    async getContractTxList() {
      let formData = new FormData();
      let params = {
        standard: "ERC-20",
        pageNum: this.pageNum,
        pageSize: 20,
      };
      let item = params;

      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await ContractTxList(formData);
      // console.log(res);
      var calctime = new Date();
      //let strdate = Math.floor(calctimea.getTime() / 1000);
      let strdate = Math.floor(calctime.getTime() / 1000);
      this.list1 = res.result.list;
      // console.log(this.list1);
      this.total = res.result.count;
      for (var i = 0; i < this.list1.length; i++) {
        if (this.list1[i].symbol.trim() == "") {
          if (this.list1[i].contractName.trim() !== "") {
            this.list1[i].symbol = this.list1[i].contractName;
          } else {
            this.list1[i].symbol = getSubStr(
              this.list1[i].contractAddress,
              0,
              3
            );
          }
        } else {
          this.list1[i].symbol = this.list1[i].symbol;
        }

        if (this.list1[i].tokenAmount.length > 8) {
          this.list1[i].tokenAmount =
          formattedNumber(this.list1[i].tokenAmount.slice(0, 8)) +
            "...";
        } else {
          this.list1[i].tokenAmount = formattedNumber(this.list1[i].tokenAmount);
        }
        this.list1[i].txHash1 = getSubStr(this.list1[i].txHash, 0, 6);
        this.list1[i].toEvmAddress1 = getSubStr(
          this.list1[i].toEvmAddress,
          0,
          6
        );
        this.list1[i].fromEvmAddress1 = getSubStr(
          this.list1[i].fromEvmAddress,
          0,
          6
        );
        // this.list1=getSubStr(this.list1[i].txHash,0,6);
        let timestamp = Math.floor(this.gltime(this.list1[i].tradeTime) / 1000);
        var s = strdate - timestamp;
        if (s <= 0) {
          s = 1;
        }
        this.list1[i].tradeTime = formatSeconds(s);
        if (this.list1[i].logo == "") {
          this.list1[i].logo = this.imgurl;
        }
        if (this.list1[i].symbol == "") {
          this.list1[i].symbol = this.list1[i].contractName;
        }
        //this.list1[i].logo
        //this.list1[i].type = listTypea(this.list1[i].type);
      }
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
    goDetail(name, query) {
      //  console.log(query);
      switch (name) {
        case "address":
          this.$router.push({
            path: "/m/Address",
            query: { address: query },
          });
          break;
        case "txnhash":
          this.$router.push({
            path: "/m/TransferDetails",
            query: { txHash: query.txHash, type: 8, standard: query.standard },
            // query: { txHash: query },
          });
          break;
        case "hash":
          if (query.standard == "ERC-20") {
            //    console.log(111);
            let params = {
              contractAddress: query.contractAddress,
            };
            this.$router.push({ path: "/m/Overaddress", query: params });
          }
          break;
        case "height":
          this.$router.push({
            path: "/m/BlockHeight",
            query: { height: query },
          });
          break;
      }
    },
  },
  watch: {
    $route: {
      handler(val, oldval) {},
      deep: true,
    },
  },
};
</script>
<style lang="less">
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #22252e;
  color: #fff;
  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  border: none;
}
.el-pager li {
  margin: 0px 6px !important;
  padding: 0px 6px !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  background: none;
  color: #adb0c7;
  width: 10px !important;
}

.el-pagination.is-background .el-pager li {
  padding-left: 6px;
  padding-right: 6px;
  height: 48px;
  margin: 0 10px;
  //background: #3c485c;
  background: none;
  border-radius: 8px;
  opacity: 1;

  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 48px;

  text-align: center;
}
</style>

<style lang="less" scoped>
.index {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #13161b;
  text-align: center;

  .translist {
    width: 100%;
    overflow: hidden;
    margin-top: 24px;
    background: #13161b;
    .Block_Top {
      text-align: left;
      width: 702px;
      height: 80px;
      line-height: 80px;
      margin: 0 auto;
      background: #0b0c0f;
      border-radius: 24px 24px 0 0;
      span {
        font-size: 30px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-left: 24px;
      }
      b {
        margin-left: 10px;
      }
    }
    //轮播图片开始
    .resume-list {
      width: 702px;
      background: #0b0c0f;
      border-radius: 0 0 24px 24px;
      margin: 0 auto;
      .pool_main {
        width: 100%;
      }
      .tags {
        display: flex;
        overflow: auto;
        white-space: nowrap;
      }
      //隐藏滚动条
      .tags::-webkit-scrollbar {
        display: none;
      }
      // 列表开始
      .indexList {
        width: 100%;
        margin: 0;
        padding: 0;
        background: #0b0c0f;
        .Block_list {
          .block_list_Top {
            display: flex;
            width: 2000px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 400px;
            }
            li:nth-child(2) {
              width: 200px;
            }
            li:nth-child(3) {
              width: 400px;
            }
            li:nth-child(4) {
              width: 300px;
            }
            li:nth-child(5) {
              width: 300px;
            }
            li:nth-child(6) {
              width: 400px;
            }
            // li:nth-child(7) {
            //   width: 200px;
            // }
          }
        }
        .Block_List_center {
          width: 2000px;
          ul {
            //  height: 800px;
            width: 2000px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #22252e;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                text-align: left;
                // flex: 0 0 14%;
              }
            }
            li:last-child {
              // border-bottom: none;
            }
            p:nth-child(1) {
              width: 400px;
              // border: 1px solid red;
            }
            p:nth-child(2) {
              width: 200px;
              color: #8a8a8a;
            }
            p:nth-child(3) {
              width: 400px;
              color: #8a8a8a;
            }
            p:nth-child(4) {
              width: 300px;
            }
            p:nth-child(5) {
              width: 300px;
            }
            p:nth-child(6) {
              width: 400px;
              color: #8a8a8a;
              margin-right: 4px;
              img {
                width: 30px;
                height: 30px;
                margin-top: 24px;
                margin-right: 10px;
                border-radius: 50%;
                margin-left: 10px;
              }
            }
            // p:nth-child(7) {
            //   width: 200px;
            // }
          }
        }
      }
      .block {
        margin-top: 70px;
        padding-bottom: 70px;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
        // line-height: 39px;
      }
    }

    //轮播图片结束
  }
  .list {
    text-align: center;
    padding-bottom: 80px;
    .list-data {
      margin: 0px auto;
      width: 690px;
      // min-height: 1377px;
      background: #232a35;
      border-radius: 24px 24px 24px 24px;
      opacity: 1;
      .head {
        width: 690px;
        padding: 24px 12px;
        background: #232a35;
        opacity: 1;
        border-radius: 16px 16px 16px 16px;
        padding-left: 30px;
        text-align: left;
        height: 48px;
        font-size: 32px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.9);
        line-height: 48px;
      }
      .list-height {
        // min-height: 1377px;
        .content_center {
          text-align: left;
          padding: 40px 0px 40px 0px;
          font-size: 26px;
          font-family: "PingFang SC-中黑体, PingFang SC";
          font-weight: normal;
          color: #adb0c7;
          line-height: 36px;
          border-bottom: 1px solid #3c485c;
          margin: 0px 32px;
          div {
            display: flex;
            margin-top: 16px;
            flex-direction: row;
            justify-content: space-between;
            height: 44px;
            line-height: 44px;
            font-size: 28px;
            font-family: SF Pro Text-Medium, SF Pro Text;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.55);
          }
          span {
            padding-bottom: 10px;
            width: 440px;
            text-align: left;
            float: right;
            height: 44px;
            font-size: 28px;
            font-family: SF Pro Text-Regular, SF Pro Text;
            font-weight: 400;
            color: #00a870;
            line-height: 44px;
          }
          .black {
            height: 44px;
            font-size: 28px;
            font-family: SF Pro Text-Regular, SF Pro Text;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.9);
            line-height: 44px;
          }
          span:nth-child(4) {
            color: #2c3852 !important;
          }
          span:nth-child(5) {
            color: #2c3852 !important;
          }
        }
      }

      .block {
        margin-top: 32px;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
        line-height: 39px;
        padding-bottom: 32px;
      }
    }
  }
}
</style>
